<template>
    <v-container fluid pa-0>
        <v-row align="center" justify="center">
            <v-col class="px-0" cols="12">
                <v-card class="pa-3" color="rgba(255,255,255,0.2)">
                    <v-form ref="textAreaForm" v-model="textAreaFormIsValid">
                        <v-textarea
                                ref="text_area"
                                :rules="rules"
                                :value="innerValue"
                                @input="emitValue($event)"
                                autocomplete="off"
                                background-color="white"
                                class="elevation-2"
                                hide-details
                                label="Type your answer here..."
                                light
                                @paste.prevent
                                auto-grow
                                outlined
                                rows="4"
                                single-line
                        ></v-textarea>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "TextArea",
        props: {
            value: {
                required: true,
            }
        },
        data: () => ({
            innerValue: null,
            textAreaFormIsValid: true,
            rules: [v => !!v || 'this field is required']
        }),
        methods: {
            cloneInner() {
                this.innerValue = JSON.parse(JSON.stringify(this.value));
            },
            emitValue(event) {
                this.innerValue = event;
                if (JSON.parse(JSON.stringify(this.innerValue)) !== JSON.parse(JSON.stringify(this.value))) {
                    this.$emit('input', JSON.parse(JSON.stringify(this.innerValue)));
                }
            },
            goToNext() {
                if (this.$refs.textAreaForm.validate()) {
                    this.$emit('next');
                }
            }
        },
        mounted() {
            !!this.value && this.cloneInner();
            setTimeout(() => {
                this.$refs['text_area'].focus();
            }, 300);
        },
        watch: {
            value() {
                this.cloneInner();
            }
        }
    }
</script>

<style scoped>

</style>